import { useEffect, useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import CloseIcon from "@mui/icons-material/Close"
import {
  Avatar,
  Backdrop,
  Box,
  Button,
  DialogTitle,
  IconButton,
  Alert,
  Grid,
  Tab,
  Tabs,
  TextField,
} from "@mui/material"
import { useAppSelector, useAppDispatch } from "@/core/app/hooks"
import { RootState } from "@/core/app/store"
import FormControlLabel from "@mui/material/FormControlLabel"
import Radio from "@mui/material/Radio"
import RadioGroup from "@mui/material/RadioGroup"
import FormControl from "@mui/material/FormControl"
import FormLabel from "@mui/material/FormLabel"
import { wasmModule } from "@/gluelayer"
import { ULoading, UText } from "@/ui-component"
import DialogBox from "@/modules/Clinical/components/DialogBox/dialogBox"
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos"
import { setOpenTrimPreview } from "@/UDTreat/udTreatSlice"
import ReplayOutlinedIcon from "@mui/icons-material/ReplayOutlined"
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined"
export const TrimWindow = () => {
  const { caseDetail } = useAppSelector((state: RootState) => state.caseService)
  const { openStlPrint } = useAppSelector(
    (state: RootState) => state.udTreatService,
  )
  const dispatch = useAppDispatch()
  // trim line value
  const [trimValue, setTrimValue] = useState(0)

  const [isloading, setIsloading] = useState(false)

  const handleTrimValue = (event: React.ChangeEvent<HTMLInputElement>) => {
    const val = +event.target.value
    setTrimValue(val)
    if (val !== 3) {
      setCustom("")
    }
  }
  useEffect(() => {
    try {
      setIsloading(true)
      setTimeout(() => {
        const printMoudle = wasmModule.moduleManager.GetModulePrintSelection()
        if (printMoudle && printMoudle.SetOffsetInPreview) {
          if (trimValue === 1) {
            printMoudle.SetOffsetInPreview(0)
          }
          if (trimValue === 2) {
            printMoudle.SetOffsetInPreview(0.75)
          }
          if (
            trimValue === 3 &&
            custom !== "" &&
            typeof +custom === "number" &&
            !isNaN(+custom)
          ) {
            printMoudle.SetOffsetInPreview(+custom)
          }
        }
        setIsloading(false)
      }, 200)
    } catch (error) {
      console.error(error)
      setIsloading(false)
    }
  }, [trimValue])
  // cutstom
  const [custom, setCustom] = useState<number | string>("")
  const handleInput = (
    e: React.ChangeEvent<HTMLInputElement>,
    min: number,
    max: number,
    setVal: (arg: string | number) => void,
  ) => {
    let value = e.target.value
      .replace(/[^0-9.]/g, "") // 移除非数字和小数点
      .replace(/(\..*)\./g, "$1") // 禁止多个小数点
      .replace(/^\./, `${min}.`) // 处理单独的小数点开头
      .replace(/(\.\d{2})\d+$/, "$1") // 限制一位小数

    // 格式验证和范围修正
    if (/^\d*\.?\d*$/.test(value) && value !== "") {
      const numValue = parseFloat(value)

      if (numValue < min) {
        value = `${min}.0`
      } else if (numValue > max) {
        value = `${max}.0`
      }
    }
    setVal(value)
  }
  const handleBlurCustom = () => {
    if (custom) {
      const num = parseFloat(custom)
      setCustom(num % 1 === 0 ? num.toString() : num.toFixed(2)) // 失焦格式化
    }
  }
  // reset popup
  const [resetPopup, setResetPopup] = useState<boolean>(false)
  return (
    <Box
      sx={{
        width: "40%",
        height: "244px",
        position: "absolute",
        bottom: "0",
        padding: "16px 16px 24px 48px",
        background: "#fff",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          width: "calc(100% - 16px)",
          padding: "6px 16px",
          borderRadius: "4px",
          background: "rgba(255, 255, 255, 0.40)",
          left: "8px",
          top: "-76px",
          display: "flex",
          alignItems: "center",
        }}
      >
        <InfoOutlinedIcon sx={{ color: "#fff" }} />
        <Box
          sx={{
            color: "var(--info-contrast, #FFF)",
            fontSize: "14px",
            fontWeight: 500,
            lineHeight: "143%",
            letterSpacing: "0.15px",
            marginLeft: "12px",
            padding: "8px 0",
          }}
        >{`Adjustments will apply to all the stages selected for output.
Trim line adjustments for individual stages can be made in the next step.`}</Box>
      </Box>
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <UText variant={"h6"}>{`Trim Line Preview`}</UText>
        <Button
          onClick={() => {
            // GoToOrigin3DScene
            const printMoudle =
              wasmModule.moduleManager.GetModulePrintSelection()
            if (printMoudle) {
              printMoudle.ApplyInPreview()
              printMoudle.GoToOrigin3DScene()
              dispatch(setOpenTrimPreview(false))
            }
          }}
          variant="contained"
          sx={{ height: "30px", padding: "4px 10px" }}
          endIcon={<ArrowForwardIosIcon sx={{ fontSize: "14px!important" }} />}
        >{`Back`}</Button>
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: "7px",
          width: "400px",
        }}
      >
        <UText variant={"h7"} sxProp={{ fontWeight: 500 }}>{`Offset`}</UText>
        <Button
          onClick={() => {
            setResetPopup(true)
          }}
          variant="outlined"
          sx={{
            height: "30px",
            padding: "4px 10px",
            color: "rgba(0, 0, 0, 0.87)",
            borderColor: "rgba(0, 0, 0, 0.87)",
          }}
          endIcon={<ReplayOutlinedIcon sx={{ fontSize: "14px!important" }} />}
        >{`reset`}</Button>
      </Box>
      <Box sx={{ position: "relative" }}>
        <FormControl>
          <FormLabel
            id="toothPosition"
            sx={{ color: "rgba(0, 0, 0, 0.6)" }}
          >{`Distance between gumline and trimline `}</FormLabel>
          <RadioGroup
            sx={{ marginLeft: "10px" }}
            aria-labelledby="toothPosition"
            name="radio-buttons-group"
            value={trimValue}
            onChange={handleTrimValue}
          >
            <FormControlLabel value={1} control={<Radio />} label="No offset" />
            <FormControlLabel value={2} control={<Radio />} label="0.75 mm" />
            <FormControlLabel
              value={3}
              control={<Radio />}
              label="Custom offset ( 0~2 mm)"
            />
          </RadioGroup>
        </FormControl>
        <Box
          sx={{
            position: "absolute",
            display: "flex",
            top: "126px",
            left: "260px",
          }}
        >
          <TextField
            sx={{
              width: "44px",
              height: "24px",
              "& .MuiInputBase-input": { padding: "0", textAlign: "center" },
            }}
            value={custom}
            onChange={(e) => {
              handleInput(e, 0, 2, setCustom)
            }}
            onBlur={handleBlurCustom}
          />
          <Button
            sx={{ height: "24px", width: "74px", marginLeft: "16px" }}
            variant="contained"
            onClick={() => {
              const printMoudle =
                wasmModule.moduleManager.GetModulePrintSelection()
              if (trimValue === 3) {
                if (
                  printMoudle &&
                  printMoudle.SetOffsetInPreview &&
                  custom !== "" &&
                  typeof +custom === "number" &&
                  !isNaN(+custom)
                ) {
                  setIsloading(true)
                  setTimeout(() => {
                    printMoudle.SetOffsetInPreview(+custom)
                    setIsloading(false)
                  }, 200)
                }
              }
            }}
          >{`UPTATE`}</Button>
        </Box>
      </Box>

      <ULoading isLoading={isloading} />
      <DialogBox
        open={resetPopup}
        title={``}
        content={`All the cut line points will be reset to the default position. Do you want to proceed?`}
        actions={
          <>
            <Button
              variant="contained"
              onClick={() => {
                setResetPopup(false)
                const printMoudle =
                  wasmModule.moduleManager.GetModulePrintSelection()
                if (printMoudle && printMoudle.ResetInPreview) {
                  setIsloading(true)
                  setTimeout(() => {
                    printMoudle.ResetInPreview()
                    setCustom("")
                    setTrimValue(0)
                    setIsloading(false)
                  }, 200)
                }
              }}
            >
              Yes
            </Button>
            <Button
              variant="contained"
              onClick={() => {
                setResetPopup(false)
              }}
            >
              Cancel
            </Button>
          </>
        }
      />
    </Box>
  )
}
